import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';
import Api from "../../services/Api";
import Header from "../../components/header/Header";

import {reverseAction, RoomInterface} from "../../interfaces/common";
import {formatAction} from "../../helpers/room";
import {addDays, dateFormatDateYear, dateFormatSoon, formatSoon} from "../../helpers/dateFunctions";
import iconCheck from "../../../assets/icons/checkmark-outline.svg"

const Room = () => {
  const api = Api.getInstance();
  const { id } = useParams();
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  const [room, setRoom] = useState<RoomInterface|null>(null);
  const [date, setDate] = useState<Date | null>(null);
  const [outdoor, setOutdoor] = useState(0)
  const [activity, setActivity] = useState(0)
  const [saved, setSaved] = useState(false)

  useEffect(() => {
    getData(null)
  }, [])

  const getData = (d: Date | null) => {
    let url = 'room/' + id
    if (d) {
      url += '?date=' + dateFormatDateYear(d)
    }
    api.get(url).then(result => {
      setRoom(result.json.room)
      setDate(new Date(result.json.date))
      setLoaded(true)
    })
  }

  const save = () => {
    const data = {
      outdoor: reverseAction[outdoor - 1],
      activity: reverseAction[activity - 1],
      date: dateFormatDateYear(date)
    }

    api.post('room/save/' + id, data).then(result => {
      setSaved(true)
      getData(date)
    })
  }

  const changeDate = (inc: number) => {
    const nextDate = addDays(date, inc)
    setSaved(false)
    getData(nextDate)
    setActivity(0)
    setOutdoor(0)
  }

  if (!loaded) {
    return (
      <div className="mt-4 p-4 bg-my-green rounded-lg">
        <h2 className="text-lg">Laddar...</h2>
      </div>
    )
  }

  return (
    <>
      <Header breadcrumbs={[{name: "Start", url: "/"}, {name: room.name}]}/>
      <div className="page">
        <div className="content">
          <div className="flex justify-between items-center">
            <h1 className="text-xl">{room.name}</h1>
            <div className="flex text-xl">
              <div className="font-medium cursor-pointer" onClick={() => changeDate(-1)}>&lt;</div>
              <div className="mx-2">{dateFormatSoon(date, 'sv', false)}</div>
              <div className="font-medium cursor-pointer" onClick={() => changeDate(1)}>&gt;</div>
            </div>
          </div>

          <div className="bg-my-green text-white rounded-lg p-4 mt-4">
            {
              room.logs.length === 0 ? (
                <div>Första loggningen för {room.name} denna dag</div>
              ) : (
                <>
                  <h2 className="text-xl">Loggat för {room.name} denna dag</h2>
                  <div className="grid grid-cols-4 mb-2 mt-4">
                    <div className="font-medium">Admin</div>
                    <div className="font-medium">Utevistelse</div>
                    <div className="font-medium">Aktivitet</div>
                    <div className="font-medium">Loggat</div>
                  </div>
                  {
                    room.logs.map((log, index) => {
                      return (
                        <div className="grid grid-cols-4 cursor-pointer" key={"log_" + index}
                             onClick={() => navigate('/room/' + room.id)}>
                          <div>{log.clientName}</div>
                          <div>{formatAction([log], "outdoor")}</div>
                          <div>{formatAction([log], "activity")}</div>
                          <div>{formatSoon(log.updatedAt, 'sv', true)}</div>
                        </div>
                      )
                    })
                  }
                </>
              )
            }
          </div>

          {
            saved ? (
              <>
                <div className="firework"></div>
                <div className="bg-my-green text-white rounded-lg p-4 mt-4">
                  <h2 className="text-xl">Tack för din loggning!</h2>
                </div>
              </>

            ) : (
              <div className="bg-my-green text-white rounded-lg p-4 mt-4">
                <h2 className="text-xl">Ny loggning för {dateFormatDateYear(date)}</h2>

                <p className="font-medium mt-4">
                  Utomhusvistelse
                </p>
                <div className="mt-2 flex items-center cursor-pointer" onClick={() => setOutdoor(1)}>
                  <div className={"my-radiobox" + (outdoor === 1 ? " checked" : "")}>
                    {
                      outdoor === 1 &&
                        <img src={iconCheck} alt="check"/>
                    }
                  </div>
                  <div className="ml-2">Inte frågat</div>
                </div>
                <div className="mt-2 flex items-center cursor-pointer" onClick={() => setOutdoor(2)}>
                  <div className={"my-radiobox" + (outdoor === 2 ? " checked" : "")}>
                    {
                      outdoor > 1 &&
                        <img src={iconCheck} alt="check"/>
                    }
                  </div>
                  <div className="ml-2">Frågat</div>
                </div>
                <div
                  className={"mt-2 flex items-center" + (outdoor < 2 ? " pointer-events-none opacity-30" : " cursor-pointer")}
                  onClick={() => setOutdoor(3)}>
                  <div className={"my-radiobox" + (outdoor === 2 ? " checked" : "")}>
                    {
                      outdoor === 3 &&
                        <img src={iconCheck} alt="check"/>
                    }
                  </div>
                  <div className="ml-2">Genomfört utomhusvistelse</div>
                </div>

                <hr className="mt-4 border-my-purple"/>

                <p className="font-medium mt-4">
                  Aktivitet
                </p>
                <div className="mt-2 flex items-center cursor-pointer" onClick={() => setActivity(1)}>
                  <div className={"my-radiobox" + (activity === 1 ? " checked" : "")}>
                    {
                      activity === 1 &&
                        <img src={iconCheck} alt="check"/>
                    }
                  </div>
                  <div className="ml-2">Inte frågat</div>
                </div>
                <div className="mt-2 flex items-center cursor-pointer" onClick={() => setActivity(2)}>
                  <div className={"my-radiobox" + (activity === 2 ? " checked" : "")}>
                    {
                      activity > 1 &&
                        <img src={iconCheck} alt="check"/>
                    }
                  </div>
                  <div className="ml-2">Frågat</div>
                </div>
                <div
                  className={"mt-2 flex items-center" + (activity < 2 ? " pointer-events-none opacity-30" : " cursor-pointer")}
                  onClick={() => setActivity(3)}>
                  <div className={"my-radiobox" + (activity === 2 ? " checked" : "")}>
                    {
                      activity === 3 &&
                        <img src={iconCheck} alt="check"/>
                    }
                  </div>
                  <div className="ml-2">Genomfört aktivitet</div>
                </div>

                <hr className="mt-4 border-my-purple"/>

                <button className="mt-4 my-button w-full" disabled={activity === 0 || outdoor === 0}
                        onClick={() => save()}>
                  Spara
                </button>

              </div>
            )
          }
        </div>
      </div>
    </>
  )
}

export default Room